import { FeatureBadge, Flex, Header, Separator } from '@driftt/dds'
import { Subnav as SideNav } from '@driftt/tide-subnav'
import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'

import { PersonaCard } from 'components/AIConfiguration/LeadQualification/PersonaCard'
import {
  StyledContent,
  StyledHeaderContainer,
} from 'components/PageLayout/PageLayout.styles'
import useContactAttributes from 'hooks/useContactAttributes'
import { useGPTQualificationAttributes } from 'hooks/useGPTQualificationAttributes'
import { getSubNavNodes } from 'utils/getSubNavNodes'

import { ConfigLoader } from './ConfigLoader'

const LeadQualification = () => {
  const {
    data: contactAttributes = [],
    isLoading: isLoadingContactAttributes,
  } = useContactAttributes()
  const {
    qualificationPersona: persona,
    isLoading: isLoadingPersonaAttributes,
  } = useGPTQualificationAttributes({
    shouldFetchAttributes: true,
  })
  const [sidebarIsOpen, setSidebarIsOpen] = useState(true)

  const SUB_NAV_NODES = getSubNavNodes()

  const isLoading = isLoadingContactAttributes || isLoadingPersonaAttributes

  return (
    <Flex direction="row" fullWidth fullHeight gap={0}>
      <SideNav
        open={sidebarIsOpen}
        nodes={SUB_NAV_NODES}
        title="Chatbot"
        NavLink={NavLink}
        style={{ height: '100%' }}
        onToggle={() => setSidebarIsOpen(!sidebarIsOpen)}
      />
      <Flex direction="column" gap={0} fullHeight fullWidth>
        <StyledHeaderContainer fullWidth>
          <Flex fullHeight alignItems="center">
            <Header>Qualification rules</Header>
            <FeatureBadge variant="beta" />
          </Flex>
        </StyledHeaderContainer>
        <Separator />
        <StyledContent fullWidth grow={1} overflow>
          {isLoading ? (
            <ConfigLoader />
          ) : (
            <Flex direction="column" gap={3}>
              <PersonaCard
                persona={persona}
                contactAttributes={contactAttributes}
              />
            </Flex>
          )}
        </StyledContent>
      </Flex>
    </Flex>
  )
}

export default LeadQualification
